import React from "react";
import { FormattedMessage } from "react-intl";

const LoadingReCaptcha = () => {
  return (
    <>
      <FormattedMessage id="RegistrationForm.loadingReCaptcha" defaultMessage="Loading reCaptcha..." />
    </>
  );
};

export default LoadingReCaptcha;
